import UserAvatar from '../../User/UserAvatar'
import formatDateInLocalTimezone from '../../utils/dateFormatting'

const LastEditedCell = () => {
  return ({ last_edited_timestamp, last_edited_by }) => {
    if (!last_edited_timestamp) {
      return null
    }

    const { name, profile_url } = last_edited_by
    const user = { ...last_edited_by, url: profile_url }
    const date = formatDateInLocalTimezone(last_edited_timestamp)

    return (
      <div className='articles-overview__table-last-edited'>
        <div className='articles-overview__table-last-edited-date'>{date + ' by '}</div>
        <UserAvatar user={user} openInNewTab style={{ width: '16px', height: '16px' }} />
        <a href={user.url} target='_blank'>{name}</a>
      </div>
    )
  }
}

export default LastEditedCell
